export const BP_TABLET = 1200;
export const BP_PHONE = 768;

